import { useMutation, gql } from '@apollo/client';
import {
  DeletarDisciplinaMutation,
  DeletarDisciplinaMutationVariables,
} from './__generated__/DeletarDisciplinaMutation';

const DELETAR_DISCIPLINA_MUTATION = gql`
  mutation DeletarDisciplinaMutation($id_disciplina: Int!) {
    deletarDisciplina(id_disciplina: $id_disciplina) {
      id_disciplina
    }
  }
`;

const useDeletarDisciplinaMutation = () => {
  return useMutation<DeletarDisciplinaMutation, DeletarDisciplinaMutationVariables>(
    DELETAR_DISCIPLINA_MUTATION
  );
};

export { useDeletarDisciplinaMutation };
